module.exports = __webpack_public_path__ + "static/media/Google_Pay_Logo.2a642f98.svg";